import { useEffect, useState } from "react";
import useApi from "./useApi";

interface WooCommerceConfig {
  id: number;
  displayName: string;
  storeName: string;
  storeUrl: string;
  enabled: boolean;
}

export default function useWooCommerceConfigs() {
  const [items, setItems] = useState<WooCommerceConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.messaging.get("WooCommerce/Integrations/Configs");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    fetchConfigs();
  }, [api.messaging]);

  return { items, loading };
}
